import { apiSlice } from "services/apiSlice";

export const bankApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanks: builder.query({
      query: () => "bank",
      providesTags: ["Bank"],
    }),

    getBanksByCompany: builder.query({
      query: (companyId) => `bank/company/${companyId}`,
      providesTags: ["Bank"],
    }),
    getBankById: builder.query({
      query: (bankId) => `bank/${bankId}`,
      providesTags: ["Bank"],
    }),
    getCurrentBank: builder.query({
      query: (companyId) => `bank/current/company/${companyId}`,
      providesTags: ["Bank"],
    }),

    createBank: builder.mutation({
      query: (data) => ({
        url: "bank",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Bank"],
    }),

    updateBank: builder.mutation({
      query: ({ id, data }) => ({
        url: `bank/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Bank"],
    }),

    deleteBank: builder.mutation({
      query: (id) => ({
        url: `bank/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Bank"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBanksQuery,
  useGetBanksByCompanyQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
  useDeleteBankMutation,
  useGetCurrentBankQuery,
  useGetBankByIdQuery,
} = bankApi;
